import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
// @ts-ignore
import { ChevronRight } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'

const Container = styled.span`
  position: relative;
  margin: 0 6px;
  &:after {
    content: '';
    display: inline-block;
    width: 16px;
    height: 16px;
  }

  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
`

const Separator = () => {
  const displayTheme = useDisplayTheme() as Theme

  return (
    <Container>
      <ChevronRight color={sys[displayTheme].text.primary} />
    </Container>
  )
}

export default Separator
